export default __webpack_public_path__ + "static/lozenge-dropdown-dont-2-dark-41a3cb1e907040ad5f65697371f32620.png";